var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9596A3",
    strokeWidth: 3,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.963 20.148 14.41 21.7l-.007.007c-2.186 2.187-5.7 2.22-7.848.071-2.148-2.148-2.117-5.662.07-7.849l.004-.004h0l1.554-1.553m4.502-4.502 1.533-1.534.044-.043c2.187-2.187 5.701-2.22 7.849-.071 2.148 2.148 2.116 5.662-.07 7.849l-.003.002h0l-1.554 1.554"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m17.444 10.889-6.223 6.222"
  }))));
};
export default SvgLink;